import { PhoneNumber } from '@/lib/phone/phoneNumber';

export const PHONE_NUMBER_REQUIRED_MESSAGE = 'The PhoneNumber field is required.';

export const PHONE_NUMBER_INVALID_MESSAGE = 'The field PhoneNumber is invalid.';

export function validateAddPhoneNumber(value: string): string | null {
  if (value.trim() === '') {
    return PHONE_NUMBER_REQUIRED_MESSAGE;
  }
  if (PhoneNumber.tryInitialize(value) === null) {
    return PHONE_NUMBER_INVALID_MESSAGE;
  }
  return null;
}
